module.exports = __webpack_public_path__ + "media/images/flags/32/Kenya-dee240387aee6d576b29897cad6ef532.png";